'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PROTOCOL = exports.PROTOCOL = {
  MOCK: 'mock:',
  FILE: 'file:',
  ABOUT: 'about:'
};
var WILDCARD = exports.WILDCARD = '*';
var WINDOW_TYPE = exports.WINDOW_TYPE = {
  IFRAME: 'iframe',
  POPUP: 'popup'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/cross-domain-utils/dist/module/constants.js
// module id = 124
// module chunks = 2